import axios from 'axios';
import { serverUrl } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const POST_LOADED = 'POST_LOADED';
export const POST_LOADING = 'POST_LOADING';
export const POST_CREATED = 'POST_CREATED';
export const POST_SINGLE_LOADING = 'POST_SINGLE_LOADING';
export const POST_SINGLE_FAILED = 'POST_SINGLE_FAILED';
export const POST_DELETED = 'POST_DELETED';
export const CHANGE_LIST='CHANGE_LIST'

export const getPosts = () => {
    return (dispatch, getState) => {
        return axios.get(
            serverUrl.Post,
        ).then(resp => {
            if (resp.status === 200) {
                const posts = resp.data.results
                const totalPosts = resp.data.rowCount
                const historyEnabled = resp.data.is_history_enabled
                dispatch({
                    type: POST_LOADED, 
                    payload: {
                        totalPosts,
                        posts,
                        historyEnabled
                    }
                });
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
        })
    }
}


export const deletePost = (postId) => {
    return (dispatch, getState) => {
        axios.delete(`${serverUrl.Post}/${postId}`).then(() => {
            dispatch({
                type: POST_DELETED, 
                payload: { postId }
            });
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
        })
    }
}

export const createPost = (showcaseName) => {
    return (dispatch, getState) => {
        dispatch({ type: POST_SINGLE_LOADING })
        
        return axios.post(
            serverUrl.Showcase,
            { showcase_name: showcaseName }
        ).then(resp => {
            if (resp.status === 201) {
                dispatch({ type: POST_CREATED });
                dispatch(getPosts());
            } else {
                dispatch({ type: POST_SINGLE_FAILED })
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
            dispatch({ 
                type: POST_SINGLE_FAILED, errors: [err]
            })
        })
    }
}

export const getChange=(change)=>{
    return {
        type: CHANGE_LIST,
        payload: {change}
    }
}